export default "__VITE_PUBLIC_ASSET__686209a6__"